export default __webpack_public_path__ + "static/media/YouTube.6d4c13e5.svg";